<template>
  <div class="seckill-sketch">
    <div class="title">
      秒杀商品页示意图
      <span v-if="data.length > 0" class="bangsToggle">
        <el-switch v-model="isBangsShow" active-color="#3e6ef7" inactive-color="#f5f5f5" />刘海屏
      </span>
    </div>
    <div v-if="data.length > 0" class="block r-mt-6 finalPage">
      <div v-if="isBangsShow" class="bangs" />
      <div class="blockContent relative-position">
        <img :src="sketchGroupImgs[0] || defaultImg" alt="" class="img" /><span
          v-if="displayConfig.isCountdown" class="group-time"
        > 距离结束X天XX小时 </span>

        <div
          class="group-tip"
          :style="{ 'background-image': `url(${displayConfig.tagBackPic})` }"
        >
          <span class="group-price-text">{{ displayConfig.tagName }}</span>
          <span class="group-price">
            <span v-if="displayConfig.displayType === 1 || mustBuyData.length > 4" class="font-size-8">￥<span
              class="font-size-18"
            >{{ sumPrice }}</span><span
              v-if="showOriginPrice"
              class="font-size-8 font-strike r-pl-8"
            >￥{{ sumOPrice }}</span></span>
            <span v-for="(item, index) in mustBuyData" v-else class="font-size-8">￥<span class="font-size-18">{{
              item.skuItems[0].price
            }}</span><span
              v-if="index !== mustBuyData.length - 1"
              class="font-size-8"
            >+</span></span>
          </span>
        </div>
      </div>
      <div class="goods-list">
        <div class="goods-name r-mb--12">
          当前秒杀组已选中<span class="text-red font-bold r-px-6 r-py-0">{{ data | fiflength }}</span>件商品
        </div>
        <div class="goods-item-block r-pa-12">
          <div class="wid-167 flex-inline scroll-x">
            <div v-for="item in newData" class="goods-item">
              <div
                class="goods-img relative-position"
                :style="{ border: item.isMustBuy == 1 || item.isDefault == 1 ? '1px solid red' : '1px solid #eee' }"
              >
                <img :src="item.productImage || defaultImg" class="height-100 width-100" style="object-fit: contain" />
                <div
                  v-if="item.isMustBuy == 1"
                  class="absolute bottom-0 width-100 text-white center line-height-16 bg-red"
                >
                  必选
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr style="border: 6px solid #f2f2f2" />
      <!-- <div class="pro-info">
        <div class="pro-sku r-mt-6">
          <div class="title">
            参数
          </div>
          <div class="r-ml-10" style="flex-grow: 2">
            品牌 型号...
          </div>
          <div class="more">
            <i class="iconfont icongengduo" />
          </div>
        </div>
      </div> -->
      <hr style="border: 6px solid #f2f2f2" />
      <div class="blockContent">
        <img v-for="(item, index) in sketchGroupImgs" v-if="index > 0" :key="index" :src="item" alt="" class="img" />
      </div>
      <div class="bottomBar">
        <div class="tools-button">
          <div>
            <i class="el-icon-s-home font-size-22 r-mb-8 r-mt-4" />
            <p>首页</p>
          </div>
          <div>
            <i class="iconfont iconlianxidaogou" />
            <p>客服</p>
          </div>
          <div>
            <i class="iconfont iconfenxiang2" />
            <p>分享</p>
          </div>
        </div>
        <div class="buy-button">
          {{ buttonName }}
        </div>
      </div>
    </div>
    <div v-else class="default-show" />
  </div>
</template>

<script>
import { toDecimal2 } from '@/util';
import { defaultImg } from '@/views/components/newDisplayConfig/shop';

export default {
  filters: {
    fiflength(list) {
      let length = 0;
      list.forEach((el) => {
        if (el.isDefault == 1 || el.isMustBuy == 1) {
          length = length + 1;
        }
      });
      return length;
    },
  },
  props: ['data', 'sketchGroupImgs', 'displayConfig', 'buttonName'],
  data() {
    return {
      isBangsShow: false,
      sumPrice: 0,
      sumOPrice: 0,
      defaultImg,
    };
  },

  computed: {
    newData() {
      const mustBuy = this.data.filter((el) => {
        return el.isMustBuy == 1 && el.isDefault == 1;
      });
      const defaultBuy = this.data.filter((el) => {
        return el.isMustBuy == 0 && el.isDefault == 1;
      });
      const notBuy = this.data.filter((el) => {
        return el.isDefault == 0;
      });
      return mustBuy.concat(defaultBuy, notBuy);
    },
    mustBuyData() {
      const mustBuy = this.data.filter((el) => {
        return el.isMustBuy == 1 && el.isDefault == 1;
      });
      const defaultBuy = this.data.filter((el) => {
        return el.isMustBuy == 0 && el.isDefault == 1;
      });
      return mustBuy.concat(defaultBuy);
    },
    showOriginPrice() {
      let sumOPrice = 0
      let sumPrice = 0
      this.data.forEach((el) => {
        if (el.isDefault == 1 || el.isMustBuy == 1) {
          let item = el['skuItems'][0];
          el.skuItems.forEach((ee) => {
            if (item['price'] > ee['price']) {
              item = ee;
            }
          });
          sumPrice = sumPrice + item['price'];
          sumOPrice = sumOPrice + item['originPrice'];
        }
      });
      this.getSumPrice()
      return sumPrice < sumOPrice;
    },

  },

  methods: {
    getMiniValue(item, key) {
      if (item.isDefault || item.isMustBuy) {
        const price = item.skuItems.map((i) => {
          return +i[key];
        });
        return toDecimal2(Math.min.apply(Math, price)) || '';
      }

    },
    getSumPrice(){
      let sumOPrice=0
      let sumPrice=0
      this.data.forEach((el) => {
        if (el.isDefault == 1 || el.isMustBuy == 1) {
          let item = el['skuItems'][0];
          el.skuItems.forEach((ee) => {
            if (item['price'] > ee['price']) {
              item = ee;
            }
          });
          sumPrice = sumPrice + item['price'];
          sumOPrice = sumOPrice + item['originPrice'];
          this.sumOPrice=sumOPrice
          this.sumPrice=sumPrice
        }
      });
    },
    }
};
</script>

<style lang="less" scoped>
.seckill-sketch {
  position: relative;
  width: 375px;

  .title {
    display: flex;
    justify-content: space-between;

    line-height: 30px;
  }

  .default-show {
    height: 375px;
    background-color: #f5f5f5;
    overflow: hidden;
  }

  .finalPage {
    >.bangs {
      width: 200px;
      height: 30px;
      background: url(../../../../static/img/phoneHead.png) no-repeat center #060606;
      background-size: 100px;
      border-radius: 0 0 20px 20px;
      position: absolute;
      top: 30px;
      left: calc(50% - 100px);
      z-index: 5;
    }

    .img {
      width: 100%;
    }

    .group-time {
      position: absolute;
      bottom: 17.5%;
      right: 12px;
      font-size: 8px;
      padding: 2px 4px;
      text-align: center;
      width: 120px;
      border-radius: 16px;
      color: #ffffff;
      background-color: #E43834;
    }

    .group-tip {
      background-image: url("https://ssl-picture.tenyun.runsasoft.com/17c653c021ee11edbc6f9f0cd6b88bcb.png");
      background-size: 100% 100%;
      background-position: center;
      height: 64px;
      width: 100%;
      position: relative;
      color: #ffffff;

      .group-price-text {
        position: absolute;
        top: 8px;
        left: 10px;
        font-size: 8px;
        color: #ffffff;
      }

      .group-price {
        position: absolute;
        bottom: 5px;
        left: 10px;
        font-size: 24px;
      }

      .group-num {
        position: absolute;
        top: 10px;
        right: 10px;
        border-radius: 4px;
        color: #ffffff;
      }

    }

    .pro-name {
      position: relative;
      padding: 12px 48px 12px 12px;
      background: #ffffff;
      font-size: 14px;
      color: #000000;
      word-break: break-all;
    }

    .pro-info {
      padding: 12px;
      font-size: 12px;

      .pro-sku {
        display: flex;
        line-height: 30px;
        justify-content: space-between;

        .title,
        .more {
          color: #999999;

          .iconfont {
            font-size: 12px;
          }
        }
      }
    }

    .bottomBar {
      box-shadow: 0 0 24px rgba(0, 0, 0, 0.08);
      padding: 12px;
      display: flex;
      justify-content: space-between;
      margin-top: 12px;
      align-items: center;

      .tools-button {
        line-height: 32px;
        display: flex;
        justify-content: space-between;
        width: 40%;
        color: #999999;
        text-align: center;

        p {
          line-height: 14px;
        }
      }

      .iconfont {
        font-size: 20px;
        color: #999999;
      }

      .buy-button {
        padding: 6px 18px;
        color: #ffffff;
        font-size: 14px;
        background: #ff4444;
        border-radius: 36px;
      }
    }
  }

  .goods-list {
    .goods-name {
      font-size: 12px;
      color: #999999;
      line-height: 40px;
      height: 40px;
      padding-left: 12px;
    }

    .goods-item-block {
      .goods-item {
        display: inline-block;
        margin-right: 10px;
        position: relative;

        .goods-img {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid #eee;
        }
      }
    }
  }
}
</style>
